import { AccountList } from '@repo/accounts-types'
import { ApiResponse, GenericOperationState } from '@repo/core'
import { RootState } from '../../store/types'

export const accountListDataSelectorConfig = {
  accountListDataSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ApiResponse<AccountList> | null> {
      return state.accounts.list.data
    },
  },
}
